import { useContext } from "react";
import { ConfigContext } from "../../util/ConfigContext";
import { DynamicForm } from "../../util/DynamicForm";
import { useGeneratedForm } from "../../hooks/useGeneratedForm";
import { apiPost } from "../../util/axiosUtil";
import API_URL from "../../config/apiConfig";
import { z } from "zod";
import MutationHandler from "../../util/MutationHandler";

export default function ZoomAccountForm({ onCancel, onSuccess }) {
  const { jwt } = useContext(ConfigContext);
  const isVideoTenant = jwt.iv;
  // const [success, setSuccess] = React.useState(null);
  // const [error, setError] = React.useState(null);
  //   const { config } = React.useContext(ConfigContext);
  const CREATE_ZOOM_URL = `${API_URL}/api/zooms`;

  const formConfig = {
    email: {
      label: "Email",
      type: "email",
      placeholder: "Enter your Email",
      defaultValue: "",
      required: true,
      validation: z
        .string()
        .optional()
        .superRefine((value, ctx) => {
          if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: "Invalid email format",
            });
          }
        }),
    },
    sdkKey: {
      label: "SDK Key",
      type: "text",
      placeholder: "Enter Sdk Key",
      defaultValue: "",
      required: true,
      normalize: (val) => val.replace(/\s+/g, ""),
      validation: z.string().superRefine((value, ctx) => {
        if (!value.trim()) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Sdk Key is required",
          });
        }
      }),
    },
    sdkSecret: {
      label: "SDK Secret",
      type: "text",
      placeholder: "Enter Sdk Secret",
      defaultValue: "",
      required: true,
      normalize: (val) => val.replace(/\s+/g, ""),
      validation: z.string().superRefine((value, ctx) => {
        if (!value.trim()) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Sdk Secret is required",
          });
        }
      }),
    },
    // password: {
    //   label: "Password",
    //   type: "password",
    //   placeholder: "Enter password",
    //   defaultValue: "",
    //   required: false,
    // },
    apiKey: {
      label: "API Key",
      type: "text",
      placeholder: "Enter API Key",
      defaultValue: "",
      fieldType: ["Audio"],
      required: true,
      normalize: (val) => val.replace(/\s+/g, ""),
      validation: z.string().superRefine((value, ctx) => {
        if (!value.trim()) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "API Key is required",
          });
        }
      }),
    },
    apiSecret: {
      label: "API Secret",
      type: "text",
      placeholder: "Enter API Secret",
      defaultValue: "",
      fieldType: ["Audio"],
      required: true,
      normalize: (val) => val.replace(/\s+/g, ""),
      validation: z.string().superRefine((value, ctx) => {
        if (!value.trim()) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "API Secret is required",
          });
        }
      }),
    },
    accountId: {
      fieldType: ["Audio"],
      label: "Account Id",
      type: "text",
      placeholder: "Enter Account Id",
      defaultValue: "",
      required: true,
      validation: z.string().superRefine((value, ctx) => {
        if (!value.trim()) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Account ID is required",
          });
        }
      }),
    },
  };

  // 🔹 Filter fields based on tenant type
  const filteredFormConfig = Object.fromEntries(
    Object.entries(formConfig).filter(([_, config]) => {
      if (!config.fieldType || config.fieldType.length === 0) return true;
      if (isVideoTenant && config.fieldType.includes("Video")) return true;
      if (!isVideoTenant && config.fieldType.includes("Audio")) return true;
      return false;
    })
  );

  return (
    <MutationHandler
      mutationFn={(formData) => {
        const { superMaster, masters, ...postData } = formData;
        return apiPost(CREATE_ZOOM_URL, postData);
      }}
      onCancel={() => onCancel()}
      onSuccess={onSuccess}
    >
      {(mutation) => (
        <ZoomAccount
          formConfig={filteredFormConfig}
          onSubmit={(value) => mutation.mutate(value)}
          isLoading={mutation.isPending}
          onCancel={onCancel}
        />
      )}
    </MutationHandler>
  );
}
function ZoomAccount({ formConfig, onSubmit, isLoading, onCancel }) {
  const form = useGeneratedForm(formConfig, async ({ value }) => {
    onSubmit(value);
  });

  return (
    <DynamicForm
      form={form}
      formConfig={formConfig}
      isLoading={isLoading}
      onCancel={onCancel}
      buttonText={"Create Account"}
    />
  );
}
